import { get } from "lodash";
import { useMemo } from "react";
import { useGlobalConfig } from "src/contexts/global/GlobalContext";
import {
  useWorkspace,
  useWorkspaceFeatureFlags,
} from "src/contexts/global/WorkspaceContext";
import { DEFAULT_GRADIENT } from "src/consts/gradient";

export const BRANDING_KEYS = {
  appName: "appName",
  gradients: "gradients",
  logoImage: "logoImage",
  logoImage_alt: "logoImage.alt",
  logoImage_styles: "logoImage.styles",
  stockImagesDisabled: "stockImagesDisabled",
};

const getLogoImageConfig = (workspaceBranding, globalConfig) => {
  const getValue = (key) =>
    get(workspaceBranding, `logoImage.${key}`) ||
    get(globalConfig, `logoImage.${key}`);

  return {
    src: getValue("src"),
    alt: getValue("alt"),
    styles: getValue("styles"),
  };
};

const getGradientValue = (workspaceBranding, globalConfig) => {
  return (
    get(workspaceBranding, BRANDING_KEYS.gradients) ||
    get(globalConfig, `${BRANDING_KEYS.gradients}[0]`) ||
    DEFAULT_GRADIENT
  );
};

export const getBrandingValues = (globalConfig = {}, workspace = {}) => {
  const workspaceBranding = get(workspace, "config.branding", {});

  return {
    appName: globalConfig.appName,
    gradients: getGradientValue(workspaceBranding, globalConfig),
    logoImage: getLogoImageConfig(workspaceBranding, globalConfig),
    stockImagesDisabled: get(
      globalConfig,
      BRANDING_KEYS.stockImagesDisabled,
      false
    ),
  };
};

const useGetBranding = () => {
  const globalConfig = useGlobalConfig();
  const workspace = useWorkspace();
  const workspaceFeatureFlags = useWorkspaceFeatureFlags();

  const branding = useMemo(() => {
    // don't use workspace branding if it's not enabled
    const enableWorkspaceSettings =
      workspaceFeatureFlags?.enableWorkspaceSettings ?? false;

    return getBrandingValues(
      globalConfig?.config,
      enableWorkspaceSettings ? workspace : {}
    );
  }, [workspaceFeatureFlags, globalConfig?.config, workspace]);

  return branding;
};

export default useGetBranding;
